import translations from '../containers/translate/translations.json';

export const translate_GET = 'translate/translateGET';


const initialState = {

}

export default (state=initialState, action) =>{
    switch(action.type){
        case translate_GET:
            return{
                ...state,
				translateData: action.payload,
            };

            default:
                return state;
    }
}

export const translateGet = (payload) => {
    return dispatch =>{
        dispatch({
            type:translate_GET,
            payload:translations,
        });
        return Promise.resolve(translations);
    }
}

export const translationResultGet = (id) => {
    const translatedWord = translations.results.find(
        value => value.translationId == id
    );

    return Promise.resolve(translatedWord);
}
